import $ from 'jquery';

import { createApp } from '#public_ts/vue/app';

import App from '../pages/main-menu/app.vue';

$(() => {
    if(document.getElementById('menu-block')) {
        createApp(App, '#menu-block');
    }
});
